import { Game } from '../../model/Game'
import { GameSnapshotter, Snapshot } from '../../model/Snapshot'
import { VersionedEvent } from '../EventSourced'

export enum GameEventKind {
  Created = 'poker:game:created',
  Start = 'poker:game:start',
  Sleep = 'poker:game:sleep',
  Pause = 'poker:game:pause',
  Resume = 'poker:game:resume',
  End = 'poker:game:end',
  SnapshotForPlayer = 'api:user:game:snapshot:for:player'
}

export interface GameEvent extends VersionedEvent {
  id: string
  timestamp: number
  kind: GameEventKind
  snapshot: Snapshot
}

export class GameEvents {
  static created(game: Game) {
    return GameEvents.createEvent(GameEventKind.Created, game)
  }

  static started(game: Game) {
    return GameEvents.createEvent(GameEventKind.Start, game)
  }

  static sleep(game: Game) {
    return GameEvents.createEvent(GameEventKind.Sleep, game)
  }

  static paused(game: Game) {
    return GameEvents.createEvent(GameEventKind.Pause, game)
  }

  static resumed(game: Game) {
    return GameEvents.createEvent(GameEventKind.Resume, game)
  }

  static ended(game: Game) {
    return GameEvents.createEvent(GameEventKind.End, game)
  }

  static createEvent(eventKind: GameEventKind, game: Game) {
    return <GameEvent>{
      name: eventKind,
      timestamp: Date.now(),
      kind: eventKind,
      snapshot: GameSnapshotter.forGame(game)
    }
  }
}
